<template>
	<div class="pages">
		<div v-for='(item,index) in templateData.TemplateContent.Controls' :key='index'>
			<Digit v-if='item.Property.Control=="Number"' :data-val='item'></Digit>
			<Contact v-if='item.Property.Control=="Condition"' :data-val="item"></Contact>
			<Dates v-if='item.Property.Control=="Date"' :data-val="item"></Dates>
			<Version v-if='item.Property.Control=="Text"' @child-event='getTextVal' :data-val="item"></Version>
			<Money v-if='item.Property.Control=="Money"' :data-val="item"></Money>
			<Tips v-if='item.Property.Control=="Tips"' :data-val="item"></Tips>
			<File v-if='item.Property.Control=="File"' :data-val="item"></File>
			<Table v-if='item.Property.Control=="Table"' :data-val='item'></Table>
			<Selector v-if='item.Property.Control=="Selector"' @child-event='getSelectorVal' :data-val='item'></Selector>
			<Textarea v-if='item.Property.Control=="Textarea"' :data-val='item'></Textarea>
		</div>


		<Button class="submit-process" v-on:click='submit' size="large" type="primary"> 提交 </Button>
	</div>
</template>

<script>
	/**
	 * Version 为Text文本组件
	 */
	import Digit from '../components/Number.vue'
	import Contact from '../components/Contact.vue';
	import Dates from '../components/Date.vue';
	import Version from '../components/Text.vue';
	import Money from '../components/Money.vue';
	import Tips from '../components/Tips.vue';
	import File from '../components/File.vue';
	import Table from '../components/Table.vue';
	import Selector from '../components/Selector.vue';
	import Textarea from '../components/Textarea.vue';
	import wx from 'weixin-js-sdk'
import {
		formatDate
	} from '@/utils/date'
	// import {
	// 	initWxConfig
	// } from "../api/jssdk.js";
	import stringUtils from "../assets/js/stringUtil.js";
	import {
		getTemplateInfo,
		submitProcess,
		sendMessage,
		getFlowTemplate
	} from '@/api/approval'

	var templateData = {
		TemplateContent: {
			Controls: []
		}
	};
	var logInfo = null;

	var isSubmit = false;

	export default {
		components: {
			Contact,
			Dates,
			Version,
			Money,
			Tips,
			File,
			Table,
			Digit,
			Selector,
			Textarea
		},
		data() {
			return {
				"templateData": templateData
			}
		},
		mounted() { //页面挂载
			// initWxConfig(this);
			this.getTemplate();
		},
		created() {
		},
		methods: { //方法
			
			getTemplate:async function() {
				let that = this;
				console.log(this.$configure.logInfo);
				// console.log(stringUtils.GetQueryString("templateId"))
				that.$http({
					url: that.$httpUrl.getTemplate + "?templateId=" + stringUtils.GetQueryString("templateId"),
					method: "get",
				}).then(async res => {
					console.log(res)
					if (res.data == null || res.data.ErrCode != 0) {
						that.$Message.error({ //error： 错误信息、success：成功、info：普通、warning：警告
							background: true,
							content: '模板获取错误'
						});
						return;
					}
					var controls = res.data.Body;
					that.templateData = res.data.Body;
					if (that.templateData == null) {
						alert("模板获取错误");
						return;
					}
					logInfo = JSON.parse(localStorage.getItem('logInfo'));
					if (logInfo == null) {
						logInfo = JSON.parse(stringUtils.getCookies("logInfo"));
					}
					for (var i = 0; i < that.templateData.TemplateContent.Controls.length; i++) {
						if (that.templateData.TemplateContent.Controls[i].Property.Title[0].Text == "部门") {
							that.templateData.TemplateContent.Controls[i].Value = logInfo.DeptName;
						} else if (that.templateData.TemplateContent.Controls[i].Property.Title[0].Text == "人员") {
							that.templateData.TemplateContent.Controls[i].Value = logInfo.EmpName;
						} else if (that.templateData.TemplateContent.Controls[i].Property.Title[0].Text == "代码"||that.templateData.TemplateContent.Controls[i].Property.Title[0].Text == "工号") {
							that.templateData.TemplateContent.Controls[i].Value = logInfo.EmpNo;
						} else if (that.templateData.TemplateContent.Controls[i].Property.Title[0].Text == "签约时间"||that.templateData.TemplateContent.Controls[i].Property.Title[0].Text == "入职时间") {
							that.templateData.TemplateContent.Controls[i].Value = logInfo.InCompanyDate;
						} else if (that.templateData.TemplateContent.Controls[i].Property.Title[0].Text == "联系电话") {
							that.templateData.TemplateContent.Controls[i].Value = logInfo.Mobile;
						} else if (that.templateData.TemplateContent.Controls[i].Property.Title[0].Text == "流程条件") {
							that.templateData.TemplateContent.Controls[i].Value = logInfo.JobLevel <= 6 ? 1 : 2;
						}else if (that.templateData.TemplateContent.Controls[i].Property.Title[0].Text == "申请时间") {
							let date = new Date();
							that.templateData.TemplateContent.Controls[i].Value = formatDate(date,"yyyy-MM-dd");
						} else if (that.templateData.TemplateContent.Controls[i].Property.Title[0].Text == "原职位") {
							that.templateData.TemplateContent.Controls[i].Value = "新进置业顾问1-1";
						} else if (that.templateData.TemplateContent.Controls[i].Property.Title[0].Text == "晋升职位") {
							that.templateData.TemplateContent.Controls[i].Value = "置业顾问2-1";
						} else if (that.templateData.TemplateContent.Controls[i].Property.Title[0].Text == "晋升说明") {
							that.templateData.TemplateContent.Controls[i].Value = `1、若当月入库，当月申请，审批完成时间为当月29号(2月为27号)18:00点前，新职位生效时间为入库当日。
2、若当月入库，当月申请，审批完成时间超过当月29号(2月为27号)18:00点，新职位生效时间为次月1号。
3、若当月入库，跨月申请，审批完成时间为申请当月29号(2月为27号)18:00点前，新职位生效时间为当月1号。
4、若当月入库，跨月申请，审批完成时间超过申请当月29号(2月为27号)18:00，新职位生效时间为申请次月1号。`;
						} 
					}
					this.templateData = await this.assignControlBySpNo(controls, this.spNo);
				}, err => {
					console.log(err)
				});
			},
			getTextVal() {
				console.log(this.templateData)
			},
			getSelectorVal(val) {
				var templateId = stringUtils.GetQueryString("templateId");
				var controls = this.templateData.TemplateContent.Controls;
				var i = 0;
				if (templateId == 'Bs7xbzNAeeBPD3ttT37HHJRe4KRc3bA5wURd7xTME') {
					// 是员工人事类盖章审批申请
					if (val == 'option-1595832288661' || val == 'option-1595832288662' || val == 'option-1595832288663') {
						for (i = 0; i < controls.length; i++) {
							if (controls[i].Property.Title[0].Text == '附件') {
								controls[i].Property.Require = 1;
								return;
							}
						}
					} else {
						for (i = 0; i < controls.length; i++) {
							if (controls[i].Property.Title[0].Text == '附件') {
								controls[i].Property.Require = 0;
								return;
							}
						}
					}
				}
			},
			submit() {
				let that = this;
				//数据校验
				if (!this.submitValidate(this.templateData.TemplateContent.Controls)) {
					return;
				}
				var SummaryList = [];
				var info={SummaryInfo:[]}
				info.SummaryInfo=[];
				
				var control=this.templateData.TemplateContent.Controls.filter(t=>{return t.Property.Title[0].Text == "部门"})[0]
				var info={SummaryInfo:[]}
				info.SummaryInfo=[];
				info.SummaryInfo.push({"Text":"申请部门："+control.Value,"Lang":"zh_CN"});
				SummaryList.push(info);
				
				
				var control2=this.templateData.TemplateContent.Controls.filter(t=>{return t.Property.Title[0].Text == "申请时间"})[0]
				var info={SummaryInfo:[]}
				info.SummaryInfo=[];
				var NameOfData = "";
				info.SummaryInfo.push({"Text":"申请时间："+control2.Value,"Lang":"zh_CN"});
				SummaryList.push(info);
				
				var control3=this.templateData.TemplateContent.Controls.filter(t=>{return t.Property.Title[0].Text == "签约时间"})[0]
				var info={SummaryInfo:[]}
				info.SummaryInfo=[];
				info.SummaryInfo.push({"Text":"签约时间："+control3.Value,"Lang":"zh_CN"});
				SummaryList.push(info);
				
				this.templateData.SummaryList=SummaryList;
				
				if (isSubmit) {
					this.Message({
						message: '已提交',
						type: 'warning',
						duration: 1000
					});
				}
				isSubmit = true;
				
				if(logInfo==null||logInfo.fullName.indexOf("住宅部")==-1||logInfo.JobLevel!=1||logInfo.PositionName!="新进置业顾问"){
					that.$message.error("没有申请权限");
					return;
				}
				
				isSubmit = true;
				that.$http.post(that.$httpUrl.startProcess + "?temId=" + stringUtils.GetQueryString("templateId") + "&empNo=" +
					logInfo.EmpNo + "&spNo=" + stringUtils.GetQueryString("spNo"), that.templateData).
				then(res => {
					isSubmit = false;
					console.log(res);
					if (res.data.ErrCode == 0) {
						that.$message.info("提交成功");
						that.$router.push("/index");
					} else {
						that.$message.error(res.data.ErrMsg);
					}
				}, err => {
					console.log(err)
				})
			}
		}
	}
</script>

<style scoped lang="less">
	.pages {
		padding-bottom: 14px;
	}
</style>
